import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import common from '../../common';
import config from "../../config";
import OutsideNotifier from '../../OutsideNotifier';

class JerseyManagePoints extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedJersey: null,
            playerStatusIconClicked: false,
        };
        this.timeout = null;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.player.id === null) {
            this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        }
    }

    onInfoTap = (e, player) => {
        e.stopPropagation();
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        if (player && Object.keys(player).length) {
            this.props.triggerHandlePlayerCard(true, player);
        }
    };

    onFocusLost = () => {
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
    };

    onPlayerStatusIconClicked = (e, player) => {
        e.stopPropagation();
        if (this.state.playerStatusIconClicked) {
            this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        } else {
            this.setState({ selectedJersey: player.id, playerStatusIconClicked: true });
        }
    };

    componentWillUnmount() {
        clearTimeout(this.timeout);
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
    }

    render() {
        const viewState = this.props.viewState;
        const player = this.props.player;
        const playerIndex = this.props.index;
        const { id, isCaptain, details, DBDetails, skill, isBench } = player;
        const selectedJersey = this.state.selectedJersey;
        const isPlayerSelected = selectedJersey === id;
        const showIconTooltip = isPlayerSelected && this.state.playerStatusIconClicked;
        const moreOptions = config.isMobile && selectedJersey && isPlayerSelected && !showIconTooltip;
        const captainTooltip = this.state.toShowCaptainInfo && isCaptain;
        let TPoints = DBDetails.OverallPoints;
        const isPlaying = Object.keys(player.points).length > 0;
        let pStatus = player.details.PStatus;
        let playerStatusIcon = null;
        if (isPlaying) {
            TPoints = player.points.TPoints;
        }
        if ((player.DBDetails.IsRedCard === 1) || (viewState === config.possibleActions["live"] && (player.stats && player.stats.RC > 0))) {
            pStatus = "R";
        }
        let pStatusObj = config.playerStatusObj ? config.playerStatusObj : {};
        let pStatusHeaderClass = pStatusObj[pStatus] ? pStatusObj[pStatus]["playerInfoHeaderClass"] : '';
        if (viewState === config.possibleActions["live"] || (viewState === config.possibleActions["viewpoint"] && pStatus === 'P' && pStatus === 'B')) {
            pStatusHeaderClass = "";
        }
        let hasStatus = pStatusHeaderClass !== '';

        if (hasStatus) {
            let pStatusTransKey = pStatusObj[pStatus] ? pStatusObj[pStatus]["transKey"] : '';
            let jerseyClassObj = {
                'si-active': showIconTooltip
            };
            jerseyClassObj[pStatusObj[pStatus]["playerJesreyClass"]] = true;
            jerseyClassObj[pStatusHeaderClass] = true;
            const jerseyStatusIconClass = common.makeClasses(jerseyClassObj);
            const iconTooltipClasses = common.makeClasses({
                'si-tooltip': true,
                'si-status-tooltip': true,
                'si-left-tt': (playerIndex === 0),
                'si-right-tt': (playerIndex === (this.props.numOfPlayers - 1)),
            });
            // playerStatusIcon = <div className={ jerseyStatusIconClass } onClick={ (e) => this.onPlayerStatusIconClicked(e, player) }>
            //     <span className="si-status-icon" />
            //     { showIconTooltip ? <OutsideNotifier handler={ () => this.onFocusLost() }>
            //         <div className={ iconTooltipClasses }>
            //             <span>{ this.props.trans[pStatusTransKey] }</span>
            //         </div>
            //     </OutsideNotifier> : null }
            // </div>
            playerStatusIcon = <div className={ jerseyStatusIconClass } >
                <span className="si-status-icon" >
                    <div className="si-tooltip si-status-tooltip si-left-tt">
                        <span>
                            {
                                this.props.trans[pStatusObj[pStatus]['toolTipTrans']] || pStatusObj[pStatus]['status']
                            }
                        </span>
                    </div>
                </span>
                { showIconTooltip ? <OutsideNotifier handler={ () => this.onFocusLost() }>
                    <div className={ iconTooltipClasses }>
                        <span>{ this.props.trans[pStatusTransKey] }</span>
                    </div>
                </OutsideNotifier> : null }
            </div>
        }

        const dataWrapClass = common.makeClasses({
            'si-data-wrap': true,
            'si-more-opts': (moreOptions || captainTooltip)
        });
        const teamImg = config.playerImgBase + `player-jersey/${(details.Skill === 1) ? 'GK/' : ''}${details['TID']}.png`;
        let isDisabled = false;
        if (viewState === config.possibleActions["live"]) {
            if (!isPlaying) {
                isDisabled = true;
            } else {
                TPoints = TPoints ? TPoints : 0;
            }
        } else if (viewState === config.possibleActions["viewpoint"]) {
            TPoints = TPoints ? TPoints : 0;
        }

        const hasPoints = !(TPoints === undefined || TPoints === null || TPoints === "")
        const jerseyClassName = common.makeClasses({
            'si-plyr-wrap': true,
            'si-selected': true,
            'si-disabled-plyr': isDisabled,
        });
        let clickHandler = {
            onClick: () => {
            }
        };

        clickHandler = { onClick: (e) => this.onInfoTap(e, player.details) };

        const captainClass = isCaptain ? 'si-captain-icon' : '';
        let stripVal = null;
        let stripClassesObj = {
            "si-plyr-val": true
        }

        if (hasPoints) {
            stripVal = TPoints + ' ' + this.props.trans.labelPts;
            if (viewState === config.possibleActions["live"]) {
                if (isBench) {
                    stripClassesObj["si-invalid-pts"] = true;
                } else {
                    if (isPlaying) {
                        if (TPoints < 0) {
                            stripClassesObj["si-minus-pts"] = true;
                        } else {
                            stripClassesObj["si-live-pts"] = true;
                        }
                    } else {
                        if (TPoints < 0) {
                            stripClassesObj["si-minus-pts"] = true;
                        } else {
                            stripClassesObj["si-final-pts"] = true;
                        }
                    }
                }
            } else if (viewState === config.possibleActions["viewpoint"]) {
                if (isBench) {
                    stripClassesObj["si-invalid-pts"] = true;
                } else if (TPoints < 0) {
                    stripClassesObj["si-minus-pts"] = true;
                } else {
                    stripClassesObj["si-final-pts"] = true;
                }
            }
        } else {
            const UpComingMatchesList = player.details && player.details['UpComingMatchesList'] ? player.details['UpComingMatchesList'] : [];
            let vsObj = {};
            let vsTeam = '';
            if (UpComingMatchesList.length > 0) {
                vsObj = UpComingMatchesList[0];
            }
            let homeAwayIndctr = "";
            if (vsObj.hasOwnProperty('TLoc') && vsObj['TLoc'] != "" && vsObj['TLoc'] != null && vsObj['TLoc'] != undefined && vsObj['TLoc'] != "undefined") {
                homeAwayIndctr = "(" + vsObj['TLoc'] + ")"
            }
            if (vsObj.hasOwnProperty('VsCCode')) {
                vsTeam = vsObj['VsCCode'];
            }
            stripVal = <React.Fragment>
                <span>{ this.props.trans.vs_short } </span>

                <span className="si-vsStrip">{ vsTeam }{ homeAwayIndctr ? " " + homeAwayIndctr + " " : "" }</span>

            </React.Fragment>
        }
        const stripClasses = common.makeClasses(stripClassesObj);
        let vsStrip = <div className={ stripClasses }>
            { stripVal }
        </div>;
        let playerBottomStrip = vsStrip;
        return <div className={ jerseyClassName }
            { ...clickHandler } data-skill={ player.skill } data-id={ player.id }>
            <div className={ dataWrapClass }>
                { playerStatusIcon }
                <span className={ "si-img-wrap " + captainClass } style={ { backgroundImage: "url(" + teamImg + ")" } } />
                <div className="si-plyr-pos">{ this.props.trans['short' + skill] }</div>
                <div className="si-plyr-details">
                    <span className="si-plyr-name">{ details['PDName'] }</span>
                    { playerBottomStrip }
                </div>
            </div>
        </div>
    }
}

export default withRouter(JerseyManagePoints);


// WEBPACK FOOTER //
// ./src/components/manage-team/Jersey-Manage-Team-Points.js